export const markMessageAsUnreadMutation = `
      mutation MarkMessageAsUnread($messageId: ID!) {
        markMessageAsUnread(id: $messageId)
      }
    `;
